import React from 'react';

const { Consumer, Provider } = React.createContext(null);

export { Provider, Consumer };
